import React from 'react';
import JackpotScanTote from './jackpot-scan-tote/JackpotScanToteContainer';
import JackpotScanLpn from './jackpot-scan-lpn/JackpotScanLpnContainer';
import { ContainerDetailsModel } from 'src/components/common/container-details/ContainerDetailsModel';

export enum JackpotPageStep {
    SCAN_TOTE = 'SCAN_TOTE',
    SCAN_LPN = 'SCAN_LPN'
}

interface JackpotPageProps {
    accessibleTools: string[];
}

interface JackpotPageState {
    step: JackpotPageStep;
    toteId: string;
    toteDetails: ContainerDetailsModel | null;
}

class JackpotPage extends React.Component<JackpotPageProps, JackpotPageState> {

    constructor(props: JackpotPageProps) {
        super(props);
        this.state = {
            step: JackpotPageStep.SCAN_TOTE,
            toteId: '',
            toteDetails: null
        };
    }

    private canCleanContainer = (): boolean => {
        return this.props.accessibleTools.includes('CleanContainer');
    }

    private onToteScanned = (toteId: string, toteDetails: ContainerDetailsModel) => {
        this.setState({
            step: JackpotPageStep.SCAN_LPN,
            toteId,
            toteDetails
        });
    }

    private resetToJackpotScanTote = () => {
        this.setState({
            step: JackpotPageStep.SCAN_TOTE,
            toteId: '',
            toteDetails: null
        });
    }

    public render() {
        const { step, toteId, toteDetails } = this.state;

        if (step === JackpotPageStep.SCAN_LPN && toteDetails) {
            return (
                <JackpotScanLpn
                    toteId={toteId}
                    toteDetails={toteDetails}
                    canCleanContainer={this.canCleanContainer()}
                    onCleanComplete={this.resetToJackpotScanTote}
                    onAssignComplete={this.resetToJackpotScanTote}
                />
            );
        }

        return (
            <JackpotScanTote onToteScanned={this.onToteScanned}/>
        );
    }
}

export default JackpotPage;
